<script lang="ts" setup>
import NavLogo from './NavLogo.vue'
import NavTabs from './NavTabs.vue'
import NavSearch from './NavSearch.vue'
import NavActions from './NavActions.vue'
</script>

<template>
  <header class="sticky top-0 z-50 bg-white border-b border-[#f0f0f0]">
    <div style="max-width: 1200px; width: 100%; margin: 0 auto; height: 64px; display: flex; align-items: center; justify-content: space-between; padding: 0 24px; box-sizing: border-box;">
      <div class="flex items-center">
        <NavLogo />
        <NavTabs style="margin-left: 50px" />
      </div>
      <div class="flex items-center" style="gap: 24px">
        <NavSearch />
        <NavActions />
      </div>
    </div>
  </header>
</template>
